import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { useForm, FormProvider } from 'react-hook-form';
import GovButton from '../Buttons/GovButton';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box } from '@mui/material';
import { formAdminValidation } from './FormAdmin/adminValidation';
import AdminForm from './FormAdmin/adminForm';

export default function CreateAdminModal(props) {
  const { openNewAdminModal, handleCloseNewAdmin, submitNewAdmin } = props;

  const methods = useForm({
    resolver: yupResolver(formAdminValidation),
  });

  // Handle form submission
  const onSubmit = methods.handleSubmit((data, event) => {
    console.log(data);
    event.preventDefault();
    submitNewAdmin(data);
    methods.reset();
  });

  return (
    <FormProvider {...methods}>
      <Dialog open={openNewAdminModal} onClose={handleCloseNewAdmin} fullWidth>
        <form onSubmit={onSubmit}>
          <DialogContent>
            <AdminForm />
          </DialogContent>
          <DialogActions sx={{ margin: 2 }}>
            <Box sx={{ marginRight: 2 }}>
              <GovButton
                ariaLabel={'cancel-admin-addition'}
                type={'button'}
                background={'white'}
                hoverBackground={'white'}
                onClick={handleCloseNewAdmin}
                color={'#003476'}
                borderColor={'#003476'}
                variant={'outlined'}
              >
                Ακύρωση
              </GovButton>
            </Box>
            <GovButton
              ariaLabel={'submit-admin-addition'}
              type={'submit'}
              background={'#003476'}
              borderColor={'#003476'}
              hoverBackground={'#02234e'}
              color={'white'}
              variant={'contained'}
            >
              Υποβολή
            </GovButton>
          </DialogActions>
        </form>
      </Dialog>
    </FormProvider>
  );
}
